document.addEventListener('DOMContentLoaded', () => {
  // Only on devices with real hover and desktop widths
  const mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
  if (!mq.matches) return;

    const items = document.querySelectorAll(
            'details[id^="Details-HeaderMenu-"]'
    );

  items.forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;
    let timer;

    const open = () => {
      clearTimeout(timer);
      // close any other open menus first
      items.forEach((d) => d !== details && close(d));
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
    };

    const close = (d = details) => {
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
      const s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', () => {
      timer = setTimeout(() => close(), 150); // small delay avoids flicker
    });

    // Stop the click from toggling the menu closed right after hover opened it
    summary.addEventListener('click', (e) => e.preventDefault());
  });
});